export enum UF {
  AC = 'AC',
  AL = 'AL',
  AP = 'AP',
  AM = 'AM',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MT = 'MT',
  MS = 'MS',
  MG = 'MG',
  PA = 'PA',
  PB = 'PB',
  PR = 'PR',
  PE = 'PE',
  PI = 'PI',
  RJ = 'RJ',
  RN = 'RN',
  RS = 'RS',
  RO = 'RO',
  RR = 'RR',
  SC = 'SC',
  SP = 'SP',
  SE = 'SE',
  TO = 'TO',
}

export enum VEHICLE_TYPE {
  AUTOMOVEL = 'AUTOMÓVEL',
  CAMINHAO = 'CAMINHÃO',
  CAMINHONETE = 'CAMINHONETE',
  CAMINHAO_TRATOR = 'CAMINHÃO TRATOR',
  MOTOCICLETA = 'MOTO',
  ONIBUX = 'ÔNIBUS',
  OUTRO = 'OUTRO',
}

export enum FUEL_TYPE {
  GASOLINA = 'GASOLINA',
  ETANOL = 'ETANOL',
  FLEX = 'FLEX',
  DIESEL = 'DIESEL',
  GNV = 'GNV',
  ELETRICO = 'ELÉTRICO',
}

export enum TYPE_DOCUMENT {
  RG = 'RG',
  CPF = 'CPF',
  CNPJ = 'CNPJ',
  CREDITCARD = 'CREDITCARD',
}

export enum REGISTER_ORIGIN {
  APP = 'APP',
  FROTAS = 'FROTAS'
}

export enum MONTHS {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
  SEVEN = '7',
  EIGHT = '8',
  NINE = '9',
  TEN = '10',
  ELEVEN = '11',
  TWELVE = '12',
}

export enum PATH_CREDIT_CARD{
  VISA = '/icons/visa.svg',
  AMEX = '/icons/amex.svg',
  DINERS = '/icons/diners.svg',
  ELO = '/icons/elo.svg',
  HIPERCARD = '/icons/hipercard.svg',
  MASTERCARD = '/icons/mastercard.svg',
}
